import { render, staticRenderFns } from "./versionAction.vue?vue&type=template&id=da3982f2&"
import script from "./versionAction.vue?vue&type=script&lang=js&"
export * from "./versionAction.vue?vue&type=script&lang=js&"
import style0 from "./versionAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports